export default __webpack_public_path__ + "static/media/light_01_white.b2921e50.svg";